/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { object, string } from '~utils/validation'

const validations = {
  amount: string().required('O nome é um campo obrigatório'),
}

export const defaultFormSchema = object({ ...validations })